import ApplicationController from "../editor/application_controller";
import { createRequest } from "../helpers/createRequest";
import { htmlToElement, insertAfter } from "../helpers/dom";

export default class extends ApplicationController {
  deleteTab(event) {
    if (window.confirm("Are you sure?")) {
      const link = event.target;
      const { tabId, studioId } = link.dataset;
      fetch(createRequest(`/x1/studios/${studioId}/section/${tabId}`, "DELETE"))
        .then(() => {
          link.closest("li").remove();
        })
        .catch((error) => {
          console.log(error);
        });
      this.hideDropdowns();
    }
  }

  addAssignment(event) {
    const { tabId, studioId } = event.target.dataset;
    const input = document
      .querySelector("#new-assignment")
      .content.cloneNode(true);
    const assignments = document.querySelector(`#assignments-for-${tabId}`);
    const lastAssignment = assignments.querySelector("li:last-child");
    if (lastAssignment) {
      insertAfter(input, lastAssignment);
    } else {
      assignments.appendChild(input);
    }
    const newInput = assignments.querySelector("input");
    newInput.dataset.tabId = tabId;
    newInput.dataset.studioId = studioId;
    newInput.focus();
    this.hideDropdowns();
  }

  createAssignment(event) {
    const { studioId, tabId } = event.target.dataset;
    const formData = new FormData();
    formData.append("name", event.target.value);
    fetch(
      createRequest(
        `/x1/studios/${studioId}/section/${tabId}/assignments`,
        "POST",
        formData
      )
    )
      .then((response) => response.text())
      .then((html) =>
        event.target.parentElement.replaceWith(htmlToElement(html))
      );
  }

  cancelAddAssignment(event) {
    event.target.closest("div").remove();
  }

  deleteAssignment(event) {
    if (window.confirm("Are you sure?")) {
      const link = event.target;
      const { assignmentId, studioId } = link.dataset;
      fetch(
        createRequest(
          `/x1/studios/${studioId}/assignments/${assignmentId}`,
          "DELETE"
        )
      )
        .then(() => {
          link.closest("li").remove();
        })
        .catch((error) => {
          console.log(error);
        });
      this.hideDropdowns();
    }
  }

  editAssignment(event) {
    const { assignmentId, studioId } = event.target.dataset;
    const input = document
      .querySelector("#edit-assignment")
      .content.cloneNode(true);
    const assignment = document.querySelector(`#assignment-${assignmentId}`);
    const title = assignment.querySelector("a").innerText;
    assignment.firstChild.classList.add("hidden");
    assignment.appendChild(input);
    const newInput = assignment.querySelector("input");
    newInput.dataset.assignmentId = assignmentId;
    newInput.dataset.studioId = studioId;
    newInput.value = title;
    newInput.focus();
    this.hideDropdowns();
  }

  cancelEditAssignment(event) {
    const cancelButton = event.currentTarget;
    cancelButton.closest("li").querySelector("a").classList.remove("hidden");
    cancelButton.parentElement.remove();
  }

  updateAssignment(event) {
    const { assignmentId, studioId } = event.target.dataset;
    const formData = new FormData();
    formData.append("name", event.target.value);
    fetch(
      createRequest(
        `/x1/studios/${studioId}/assignments/${assignmentId}`,
        "POST",
        formData
      )
    )
      .then((response) => response.text())
      .then((html) => {
        const link = event.target.closest("li").firstChild;
        link.innerText = event.target.value;
        link.classList.remove("hidden");
        event.target.parentElement.remove();
        this.hideDropdowns();
      });
  }

  toggleHidden(event) {
    const { studioId, tabId } = event.target.dataset;
    event.target.closest("li").classList.toggle("text-opacity-50");
    fetch(
      createRequest(`/x1/studios/${studioId}/section/${tabId}/toggle`, "POST")
    ).catch((error) => {
      console.log(error);
    });
    this.hideDropdowns();
  }

  hideDropdowns() {
    document
      .querySelectorAll('[data-target="x1--dropdown.menu"]')
      .forEach((el) => el.classList.add("hidden"));
  }

  // X1 Activity Inline Editing - Allows editing name and image without leaving the page
  editActivity(event) {
    event.preventDefault();
    const { activityId, studioId } = event.target.dataset;
    const activityCard = document.querySelector(`[data-activity-id="${activityId}"]`);
    const cardContent = activityCard.querySelector('.bg-white.rounded-lg');
    const nameElement = activityCard.querySelector('.activity-name');
    const currentName = nameElement.textContent.trim();
    const currentImageSrc = activityCard.querySelector('img').src;
    
    // Store original content
    const originalContent = cardContent.innerHTML;
    
    // Create edit form
    cardContent.innerHTML = `
      <div class="p-4 space-y-3">
        <div>
          <label class="block text-xs font-medium text-gray-700 mb-1">Name</label>
          <input type="text" 
                 value="${currentName}" 
                 class="activity-name-input w-full px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-pink">
        </div>
        
        <div>
          <label class="block text-xs font-medium text-gray-700 mb-1">Image</label>
          <img src="${currentImageSrc}" class="w-full h-32 object-cover rounded mb-2 preview-image">
          <input type="file" 
                 accept="image/*" 
                 class="activity-image-input hidden">
          <button type="button" 
                  class="upload-btn w-full px-2 py-1 bg-gray-100 text-gray-700 rounded hover:bg-gray-200 text-xs">
            Choose New Image
          </button>
        </div>
        
        <div class="flex space-x-2 pt-2">
          <button type="button" 
                  class="save-btn flex-1 px-4 py-2 bg-pink text-white rounded hover:bg-pink-600 text-sm font-medium">
            Save
          </button>
          <button type="button" 
                  class="cancel-btn flex-1 px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded hover:bg-gray-50 text-sm font-medium">
            Cancel
          </button>
        </div>
      </div>
    `;
    
    // Get elements
    const nameInput = cardContent.querySelector('.activity-name-input');
    const imageInput = cardContent.querySelector('.activity-image-input');
    const uploadBtn = cardContent.querySelector('.upload-btn');
    const previewImage = cardContent.querySelector('.preview-image');
    const saveBtn = cardContent.querySelector('.save-btn');
    const cancelBtn = cardContent.querySelector('.cancel-btn');
    
    // Handle image upload button
    uploadBtn.addEventListener('click', () => imageInput.click());
    
    // Handle image preview
    imageInput.addEventListener('change', (e) => {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          previewImage.src = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    });
    
    // Handle save
    saveBtn.addEventListener('click', () => {
      const newName = nameInput.value.trim();
      const formData = new FormData();
      
      if (newName && newName !== currentName) {
        formData.append('name', newName);
      }
      
      if (imageInput.files[0]) {
        formData.append('representative_image', imageInput.files[0]);
      }
      
      // Only send request if something changed
      if (formData.has('name') || formData.has('representative_image')) {
        fetch(
          createRequest(
            `/x1/studios/${studioId}/assignments/${activityId}`,
            'POST',
            formData
          )
        )
        .then(response => {
          if (response.ok) {
            // Update the card with new values
            cardContent.innerHTML = originalContent;
            
            // Update the name if it changed
            if (newName && newName !== currentName) {
              const updatedNameElement = cardContent.querySelector('.activity-name');
              if (updatedNameElement) {
                updatedNameElement.textContent = newName;
              }
            }
            
            // Update the image if a new one was uploaded
            if (imageInput.files[0]) {
              const updatedImage = cardContent.querySelector('img');
              if (updatedImage) {
                // Create a URL for the new image
                const reader = new FileReader();
                reader.onload = (e) => {
                  updatedImage.src = e.target.result;
                };
                reader.readAsDataURL(imageInput.files[0]);
              }
            }
          }
        })
        .catch(error => {
          console.error('Error updating activity:', error);
          // Restore original content on error
          cardContent.innerHTML = originalContent;
        });
      } else {
        // Restore original content if nothing changed
        cardContent.innerHTML = originalContent;
      }
    });
    
    // Handle cancel
    cancelBtn.addEventListener('click', () => {
      cardContent.innerHTML = originalContent;
    });
    
    // Handle ESC key to cancel
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        cardContent.innerHTML = originalContent;
        document.removeEventListener('keydown', handleEscape);
      }
    };
    document.addEventListener('keydown', handleEscape);
    
    // Focus on name input
    nameInput.focus();
    nameInput.select();
    
    this.hideDropdowns();
  }

  deleteActivity(event) {
    event.preventDefault();
    if (window.confirm('Are you sure you want to delete this activity?')) {
      const { activityId, studioId } = event.target.dataset;

      fetch(
        createRequest(
          `/x1/studios/${studioId}/assignments/${activityId}`,
          'DELETE'
        )
      )
      .then(response => {
        if (response.ok) {
          const activityCard = document.querySelector(`[data-activity-id="${activityId}"]`);
          if (activityCard) {
            activityCard.remove();
          }
        }
      })
      .catch(error => {
        console.error('Error deleting activity:', error);
      });
    }
    this.hideDropdowns();
  }

  // X1 Resource Inline Editing - Allows editing resource name and thumbnail without redirecting to old design
  // This function is specifically for X1 studios to maintain consistency with activity editing
  editResource(event) {
    event.preventDefault();
    const { resourceId, studioId } = event.target.dataset;
    const resourceCard = document.querySelector(`[data-project-id="${resourceId}"]`);
    const cardContent = resourceCard.querySelector('.bg-white.rounded-lg');
    const nameElement = resourceCard.querySelector('a[class*="text-gray-900"]');
    const currentName = nameElement.textContent.trim();
    const currentImageSrc = resourceCard.querySelector('img').src;

    // Store original content for cancel/error recovery
    const originalContent = cardContent.innerHTML;

    // Create edit form
    cardContent.innerHTML = `
      <div class="p-4 space-y-3">
        <div>
          <label class="block text-xs font-medium text-gray-700 mb-1">Name</label>
          <input type="text"
                 value="${currentName}"
                 class="resource-name-input w-full px-2 py-1 text-sm border border-gray-300 rounded focus:outline-none focus:ring-1 focus:ring-pink">
        </div>

        <div>
          <label class="block text-xs font-medium text-gray-700 mb-1">Image</label>
          <img src="${currentImageSrc}" class="w-full h-32 object-cover rounded mb-2 preview-image">
          <input type="file"
                 accept="image/*"
                 class="resource-image-input hidden">
          <button type="button"
                  class="upload-btn w-full px-2 py-1 bg-gray-100 text-gray-700 rounded hover:bg-gray-200 text-xs">
            Choose New Image
          </button>
        </div>

        <div class="flex space-x-2 pt-2">
          <button type="button"
                  class="save-btn flex-1 px-4 py-2 bg-pink text-white rounded hover:bg-pink-600 text-sm font-medium">
            Save
          </button>
          <button type="button"
                  class="cancel-btn flex-1 px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded hover:bg-gray-50 text-sm font-medium">
            Cancel
          </button>
        </div>
      </div>
    `;

    // Get elements
    const nameInput = cardContent.querySelector('.resource-name-input');
    const imageInput = cardContent.querySelector('.resource-image-input');
    const uploadBtn = cardContent.querySelector('.upload-btn');
    const previewImage = cardContent.querySelector('.preview-image');
    const saveBtn = cardContent.querySelector('.save-btn');
    const cancelBtn = cardContent.querySelector('.cancel-btn');

    // Handle image upload button
    uploadBtn.addEventListener('click', () => imageInput.click());

    // Handle image preview
    imageInput.addEventListener('change', (e) => {
      const file = e.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          previewImage.src = e.target.result;
        };
        reader.readAsDataURL(file);
      }
    });

    // Handle save
    saveBtn.addEventListener('click', () => {
      const newName = nameInput.value.trim();
      const formData = new FormData();

      if (newName && newName !== currentName) {
        formData.append('project[name]', newName);
      }

      if (imageInput.files[0]) {
        formData.append('project[image]', imageInput.files[0]);
      }

      // Only send request if something changed
      if (formData.has('project[name]') || formData.has('project[image]')) {
        fetch(
          createRequest(
            `/projects/${resourceId}`,
            'PATCH',
            formData
          )
        )
        .then(response => {
          if (response.ok) {
            // Update the card with new values
            cardContent.innerHTML = originalContent;

            // Update the name if it changed
            if (newName && newName !== currentName) {
              const updatedNameElement = cardContent.querySelector('a[class*="text-gray-900"]');
              if (updatedNameElement) {
                updatedNameElement.textContent = newName;
              }
            }

            // Update the image if a new one was uploaded
            if (imageInput.files[0]) {
              const updatedImage = cardContent.querySelector('img');
              if (updatedImage) {
                // Create a URL for the new image
                const reader = new FileReader();
                reader.onload = (e) => {
                  updatedImage.src = e.target.result;
                };
                reader.readAsDataURL(imageInput.files[0]);
              }
            }
          }
        })
        .catch(error => {
          console.error('Error updating resource:', error);
          // Restore original content on error
          cardContent.innerHTML = originalContent;
        });
      } else {
        // Restore original content if nothing changed
        cardContent.innerHTML = originalContent;
      }
    });

    // Handle cancel
    cancelBtn.addEventListener('click', () => {
      cardContent.innerHTML = originalContent;
    });

    // Handle ESC key to cancel
    const handleEscape = (e) => {
      if (e.key === 'Escape') {
        cardContent.innerHTML = originalContent;
        document.removeEventListener('keydown', handleEscape);
      }
    };
    document.addEventListener('keydown', handleEscape);

    // Focus on name input
    nameInput.focus();
    nameInput.select();

    this.hideDropdowns();
  }

  // X1 Resource Deletion - Removes resource via AJAX without page refresh
  // Only used in X1 studios for consistent UX with activities
  deleteResource(event) {
    event.preventDefault();
    if (window.confirm('Are you sure you want to delete this resource?')) {
      const { resourceId } = event.target.dataset;

      fetch(
        createRequest(
          `/projects/${resourceId}`,
          'DELETE'
        )
      )
      .then(response => {
        if (response.ok) {
          const resourceCard = document.querySelector(`[data-project-id="${resourceId}"]`);
          if (resourceCard) {
            resourceCard.remove();
          }
        }
      })
      .catch(error => {
        console.error('Error deleting resource:', error);
      });
    }
    this.hideDropdowns();
  }

  
  toggleAssignments(event) {
    event.preventDefault();
    console.log(event);
    const parentElement = event.target.closest('li');
    const assignmentsElement = parentElement.querySelector('.assignments');

    if (assignmentsElement) {
      if (assignmentsElement.style.maxHeight === '0px' || !assignmentsElement.style.maxHeight) {
        assignmentsElement.style.maxHeight = '100%';
      } else {
        assignmentsElement.style.maxHeight = '0px';
      }
    }
    console.log(event.target);
  }
}
